import SpecialtyMixin from '@/shared/mixins/specialty.mixin'
import AuthMixin from '@/shared/mixins/auth.mixin'
import RadioExamsMixin from '@/shared/mixins/radio-report.mixin'
import DateMixin from '@/shared/mixins/date.mixin'
import ExamFileMixin from '@/shared/mixins/exam-file.mixin'
import MedicalReportMixin from '@/shared/mixins/medical-report.mixin'
import PhysicianHeartbeatMixin from '@/shared/mixins/physician-heartbeat.mixin'
import feedback from '@/components/medico/feedback/index.vue'
import RadioHeader from '@/components/medico/radioHeader/index.vue'
import RepetirExame from '@/components/medico/repetir-exame/index.vue'
import Laudar from '@/components/medico/laudar-exame/index.vue'
import RadioReportPopUp from '@/components/radio-popup/index.vue'
import RadioReportPopUpDuplicate from '@/components/radio-popup-duplicate/index.vue'
import ReportKeywords from '@/components/medico/radioReport/report-keywords.json'
import CONSTANTS from '@/shared/constants/constants'
import BodyParts from '@/components/medico/radioReport/body-parts.json'
import SpecialtyConflicts from '@/components/medico/radioReport/specialty-conflicts.json'
import GenderExclusiveExams from '@/components/medico/radioReport/gender-exclusive-exams.json'
import LateralityExams from '@/components/medico/radioReport/laterality-exams.json'
import {
  checkLateralityConflict,
  findKeywordsInText,
  findStatusConflict,
  findGenderConflict,
  findBodyPartConflict,
  getConflictingGenderForSpecialty,
  collectSpecialtyKeywords
} from '@/shared/utils/report-validation-checks'
import { getReportTimerMinutesWithFallback } from '@/shared/utils/report-timer-fallback'
import AbdomenTotalTags from '@/components/medico/radioReport/abdomen-total-tags.json'
import { stringSimilarity } from 'string-similarity-js'
import { sanitizeReportText } from '@/shared/utils/sanitize-report-text'

const HEARTBEAT_INTERVAL_IN_MILLISECONDS = 60000
const STILL_REPORTING_INACTIVITY_TIMEOUT_PERCENTAGE = 0.75

export default {
  name: 'RadioReport',
  mixins: [SpecialtyMixin, AuthMixin, RadioExamsMixin, DateMixin, ExamFileMixin, MedicalReportMixin, PhysicianHeartbeatMixin],
  components: {
    RadioHeader,
    RepetirExame,
    Laudar,
    RadioReportPopUp,
    RadioReportPopUpDuplicate,
    feedback
  },
  data() {
    return {
      reportText: '',
      examSelected: null,
      items: [],
      filteredItems: [],
      query: '',
      paginatedItems: [],
      viewingObservation: false,
      currentReport: null,
      currentObservation: {},
      isLoading: false,
      interval: null,
      selectedMasks: [],
      isReadOnly: false,
      repeat: false,
      reportStatus: '',
      abnormal: null,
      masks: [],
      showMasks: false,
      showNoMasksMessage: false,
      masksLoading: false,
      showRetryButtonMasks: false,
      selectedSpecialtyId: null,
      isAbnormal: false,
      specialties: [],
      selectedSpecialty: null,
      showSpecialtyDropdown: false,
      description: '',
      pinnedExam: null,
      showDialog: 0,
      nextExamId: null,
      isMounted: false,
      hasLoaded: false,
      lastUpdated: new Date(),
      isTimerActive: false,
      examDetails: {},
      hasUrgencyAlert: false,
      lastReportText: '',
      notifications: [],
      showEditButton: true,
      isCollapsed: true,
      isTextareaDisabled: false,
      showMaintainButton: false,
      showSubmitButton: true,
      isMaintainClicked: false,
      isEditClicked: false,
      isSubmittingReport: false,
      isExamHighComplexity: false,
      isPreviousAccordionOpen: false,
      previousExamSearchId: '',
      previousExams: [],
      previousExamSearched: false,
      reportKeywords: null,
      foundKeywords: [],
      statusChangeRequired: false,
      userDecisionMade: false,
      lastValidatedText: '',
      openModalDuplicate: false,
      examDetailSelected: null,
      bodyPartsSelecteds: [],
      subSpecialties: [],
      showCpfSearch: false,
      cpfSearch: '',
      advancedSearch: {
        name: '',
        dateOfBirth: '',
        gender: ''
      },
      advancedSearchErrors: {
        name: false
      },
      obsViewed: false,
      attachmentTypes: [],
      specialtyConflicts: null,
      conflictIndexBySpeciality: {},
      conflictSpecialtyName: '',
      statusConflictKeywords: [],
      statusConflictType: 0,
      specialtyConflictKeywords: [],
      isLoadingBaseItem: false,
      baseItemInterval: null,
      isLoadingExamsQueue: false,
      genderExclusiveExams: null,
      hasGenderConflict: false,
      genderConflictExamName: '',
      genderConflictExamGender: '',
      genderConflictKeywords: [],
      lateralityExams: null,
      hasLateralityConflict: false,
      lateralityConflictSide: '',
      lateralityConflictKeywords: [],
      hasBodyPartConflict: false,
      bodyPartConflictKeywords: [],
      bodyPartExpectedName: '',
      activeWarningCount: 0,
      activeDivergences: [],
      similarityMatchPercentage: 0,
      MAX_REPORTS_HISTORY: 3,
      SIMILARITY_THRESHOLD: 0.95,
      STORAGE_KEY_SIMILARITY: 'reportSimilarityHistory',
      similarityWarningActive: false,
      lastSimilarityWarnedText: '',
      similarityUserDecisionMade: false,
      pastedText: false,
      pendingGenderConfirmation: false,
      pendingGenderConfirmationText: '',
      isOpeningXView: false,
      heartbeatInterval: null,
      hasActivitySinceLastHeartbeat: false,
      lastActivityAt: null,
      heartbeatListenersRegistered: false,
      heartbeatMouseMoveHandler: null,
      heartbeatVisibilityChangeHandler: null,
      hasNoExamsAvailable: false,
      stillReportingMonitorInterval: null,
      stillReportingExpiresAt: null,
      lastStillReportingActivityAt: null,
      stillReportingPopupVisible: false,
      isRefreshingStillReportingTimeout: false,
      pendingCheckResults: null,
      lastTriggeredCheckResults: null,
      alertReviewedFlags: {
        similarity: false,
        gender: false,
        bodyParts: false
      }
    }
  },
  async mounted() {
    await this.load()
    this.setReportKeywords()
    this.setSpecialtyConflicts()
    this.setGenderExclusiveExams()
    this.setLateralityExams()
    this.isMounted = true
    this.attachmentTypes = await this.getAttachmentTypes()
    this.$root.$on('stillReportingContinue', this.handleStillReportingContinue)
    this.startPhysicianHeartbeat()
    this.startStillReportingMonitor()
  },
  beforeDestroy() {
    this.stopTimer()
    this.stopBaseItemTimer()
    this.stopPhysicianHeartbeat()
    this.stopStillReportingMonitor()
    this.$root.$off('stillReportingContinue', this.handleStillReportingContinue)
  },
  watch: {
    query: 'filterItems',
    reportText: {
      handler(newText, oldText) {
        if (newText !== oldText) {
          this.checkAndDeselectMasks()
          if (this.userDecisionMade && newText !== this.lastValidatedText) {
            this.userDecisionMade = false
          }
          if (this.similarityWarningActive || this.similarityUserDecisionMade) {
            const normalizedNewText = this.normalizeReportText(newText)
            if (normalizedNewText !== this.lastSimilarityWarnedText) {
              this.similarityWarningActive = false
              this.lastSimilarityWarnedText = ''
              this.similarityUserDecisionMade = false
            }
          }
        }
      }
    },
    isAbnormal: {
      handler() {
        this.autoSelectSpecialtyIfOnlyOne()
        this.userDecisionMade = false
        this.lastValidatedText = ''
      }
    },
    examDetails(newVal) {
      if (newVal && newVal.retification) {
        this.showEditButton = true
        this.showMaintainButton = true
        this.showSubmitButton = false
      } else {
        this.showEditButton = false
        this.showMaintainButton = false
        this.showSubmitButton = true
      }
    },
    async examSelected(newExamId) {
      if (newExamId) {
        this.resetStillReportingMonitorState()
        if (Number(this.examDetails?.examId) !== Number(newExamId)) {
          this.examDetails = {}
        }
        await this.fetchExamDetails(newExamId)
        this.setStillReportingExamDeadline()
        this.isEditClicked = false
      }
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.sortBy = 'patientName'
          this.$refs.table.sortOrder = 'asc'
        }
      })
    },
    repeat(newValue) {
      if (newValue) {
        this.reportStatus = ''
      }
    },
    showDialog(newVal, oldVal) {
      if (
        (newVal === 4 ||
          newVal === 5 ||
          newVal === 8 ||
          newVal === 9 ||
          newVal === 10 ||
          newVal === 11 ||
          newVal === 12) &&
        newVal !== oldVal
      ) {
        this.sendShowDialogModalEvent(newVal)
      }
    }
  },
  computed: {
    sortedItems: {
      get() {
        return this.filteredItems
      },
      set(value) {
        this.filteredItems = value
      }
    },

    shouldShowSpecialtyDropdown() {
      return (
        (!this.filteredSpecialties || this.filteredSpecialties.length !== 1) &&
        !this.repeat &&
        this.reportStatus !== 'alterado' &&
        this.reportStatus !== 'normal' &&
        this.reportStatus
      )
    },
    filteredSpecialties() {
      if (!this.masks.length) return []

      const specialtiesWithMatchingMasks = this.masks
        .filter((mask) => {
          if (this.isAbnormal) {
            return Boolean(mask.isChanged) === true
          } else {
            return Boolean(mask.isChanged) === false
          }
        })
        .map((mask) => mask.specialityId)
      return [...new Set(specialtiesWithMatchingMasks)]
    },
    filteredMasks() {
      if (!this.selectedSpecialty) return []
      return this.masks.filter((mask) => {
        const hasMatchingSpecialty = mask.specialityId === this.selectedSpecialty
        const hasMatchingStatus = this.isAbnormal ? Boolean(mask.isChanged) === true : Boolean(mask.isChanged) === false

        return hasMatchingSpecialty && hasMatchingStatus
      })
    },
    currentExam() {
      const exam = this.items.find((item) => item.examId === this.examSelected)
      if (!exam) {
        return {
          examId: this.examSelected,
          patientName: '',
          birthDate: null,
          openingDate: new Date(),
          specialtyName: '',
          gender: null
        }
      }

      if (!exam.patientName || exam.patientName.trim() === '') {
        exam.patientName = `Patient ${exam.examId}`
        exam.truncatedPatientName = exam.patientName
      }

      return exam
    },
    headerExam() {
      const exam = this.currentExam || {}
      const detailsBelongToExam =
        this.examDetails &&
        typeof this.examDetails === 'object' &&
        Number(this.examDetails.examId) === Number(exam.examId)
      const detailLabels = detailsBelongToExam ? this.examDetails.labels : null

      return {
        ...exam,
        labels: detailLabels && detailLabels.length ? detailLabels : exam.labels || []
      }
    },
    formattedLastUpdated() {
      return this.$moment(this.lastUpdated).format('DD/MM/YYYY HH:mm:ss')
    },
    formattedCreationDate() {
      return this.$moment(this.examDetails.creationDate).format('DD/MM/YYYY HH:mm')
    },
    messageRadioReport() {
      if (this.showDialog === 1) {
        return this.$i18n.t('radio_report.change_exam_warning')
      }
      if (this.showDialog === 2) {
        return this.$i18n.t('radio_report.refresh_exams_warning')
      }
      if (this.showDialog === 3) {
        return this.$i18n.t('radio_report.duplicate_exam_warning')
      }

      if (this.showDialog === 10) {
        return this.buildDivergenceMessage(this.activeDivergences)
      }

      return ''
    },
    dialogPrimaryButtonText() {
      if (this.showDialog === 10) {
        return 'radio_report.send_report_anyway'
      }
      return ''
    },
    dialogSecondaryButtonText() {
      if (this.showDialog === 10) {
        return 'radio_report.review_button'
      }
      return ''
    },
    textareaHeightClass() {
      const high = this.isExamHighComplexity
      const tomo = this.isTomography(this.currentExam?.specialtyName)
      const retification = !!this.examDetails.retification
      const retificationOpen = retification && !this.isCollapsed
      const hasMasks = !!(
        this.masks.length &&
        !this.repeat &&
        this.selectedSpecialty &&
        this.reportStatus &&
        (this.reportStatus !== 'alterado' || (this.reportStatus === 'alterado' && this.filteredMasks.length > 0))
      )

      const key = `${retification ? 'R' : ''}${retificationOpen ? 'O' : ''}${high ? 'H' : ''}${tomo ? 'T' : ''}${hasMasks ? 'M' : ''}`

      const heightMap = {
        ROHTM: 'height-330',
        ROHT: 'height-330',
        ROHM: 'height-450',
        ROH: 'height-450',
        ROTM: 'height-390',
        ROT: 'height-465',
        ROM: 'height-585',
        RO: 'height-510',

        RHTM: 'height-390',
        RHT: 'height-465',
        RHM: 'height-510',
        RH: 'height-510',
        RTM: 'height-450',
        RT: 'height-510',
        RM: 'height-650',
        R: 'height-585',

        HTM: 'height-450',
        HT: 'height-510',
        HM: 'height-650',
        H: 'height-585',
        TM: 'height-510',
        T: 'height-585',
        M: 'height-650',
        '': 'height-650'
      }

      return heightMap[key] || 'height-650'
    },
    isFullAbdomen() {
      return (
        this.detectFullAbdomenByTitle() ||
        this.detectFullAbdomenByReport() ||
        this.detectFullAbdomenBySeries() ||
        this.detectAbdomenWithContrast()
      )
    },
    canSearchAdvanced() {
      const { name, dateOfBirth, gender } = this.advancedSearch
      return name && (dateOfBirth || gender)
    }
  },
  methods: {
    hasRetification(exam) {
      return exam.status === CONSTANTS.STATUS.AGUARDANDO_RETIFICACAO || exam.status === CONSTANTS.STATUS.RETIFICANDO
    },
    setReportKeywords() {
      const currentLang = this.$i18n.locale.substring(0, 2)
      this.reportKeywords = ReportKeywords[currentLang] || ReportKeywords.pt
    },
    showDuplicateExamButton() {
      return this.details?.speciality?.id === this.$constants.SPECIALITY.TOMOGRAFIA
    },
    isTomography(specialtyName) {
      return specialtyName?.toUpperCase().trim() === 'TOMOGRAFIA'
    },
    detectFullAbdomenByTitle() {
      if (!this.currentExam) return false

      const title = (this.currentExam.titleReport || '').toUpperCase().trim()
      const specialtyId = this.currentExam.specialityId || this.examDetails?.specialityId

      if (AbdomenTotalTags.specialtyIds.includes(specialtyId)) {
        return true
      }

      return AbdomenTotalTags.titlePatterns.some((pattern) => title.includes(pattern))
    },
    detectFullAbdomenByReport() {
      if (!this.reportText || this.reportText.length < 10) return false

      const text = this.reportText.toUpperCase()

      return AbdomenTotalTags.reportPatterns.some((pattern) => text.includes(pattern))
    },
    detectFullAbdomenBySeries() {
      const series = this.currentExam?.series || []

      return !!(series.includes(CONSTANTS.series.ABDOMEN) && series.includes(CONSTANTS.series.PELVIS))
    },
    detectAbdomenWithContrast() {
      const specialtyId = this.currentExam?.specialityId || this.examDetails?.specialityId

      return specialtyId === CONSTANTS.SPECIALITY.TC_ABDOME_TOTAL_COM_CONTRASTE
    },
    async handleGetListSpecialties(specialityId, sourceId) {
      const response = await this.getListSpecialties(specialityId, sourceId)
      this.subSpecialties = response || []
    },
    async handleOpenReportPopup(examId) {
      const examDetailSelected = this.items.find((item) => item.examId === examId)
      this.examDetailSelected = examDetailSelected
      this.examSelected = examId

      await this.handleGetListSpecialties(examDetailSelected.specialityId, examDetailSelected.sourceId)

      const partsFromTitle = this.splitTitleReport(examDetailSelected?.titleReport)

      if (partsFromTitle.length > 0) {
        this.bodyPartsSelecteds = partsFromTitle.map((part, index) => ({
          titleOriginal: part,
          titleNew: '',
          selectedItems: index === 0 ? [] : undefined,
          examId: index === 0 ? examId : null
        }))
      } else if (Array.isArray(examDetailSelected.bodyParts) && examDetailSelected.bodyParts.length > 0) {
        this.bodyPartsSelecteds = examDetailSelected.bodyParts.map((part, index) => ({
          titleOriginal: part,
          titleNew: '',
          selectedItems: index === 0 ? [] : undefined,
          examId: index === 0 ? examId : null
        }))
      } else {
        this.bodyPartsSelecteds = [
          {
            titleOriginal: '',
            titleNew: '',
            selectedItems: [],
            examId
          }
        ]
      }
      this.openModalDuplicate = true
    },
    splitTitleReport(title) {
      if (typeof title !== 'string') return []
      return title
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    },
    handleConfirmDuplicateExam() {
      this.showDialog = 3
    },
    handleCancelDuplicate() {
      this.openModalDuplicate = false
    },
    async handleDuplicateExam() {
      await this.duplicateExam(this.bodyPartsSelecteds)
      this.openModalDuplicate = false
      this.$root.$emit('toast', {
        message: this.$i18n.t('radio_report.duplicate_exam_success'),
        type: 'success'
      })
      await this.handleRefresh()
    },
    getLimitedBodyParts(bodyParts = []) {
      if (!bodyParts || bodyParts.length <= 2) {
        return bodyParts || []
      }
      return bodyParts.slice(0, 2)
    },

    getExtraBodyPartsText(bodyParts = []) {
      if (!bodyParts || bodyParts.length <= 2) {
        return ''
      }
      const extraCount = bodyParts.length - 2
      return `+${extraCount}`
    },

    getAllBodyPartsTooltip(bodyParts = []) {
      if (!bodyParts || bodyParts.length <= 2) {
        return ''
      }
      const extraBodyParts = bodyParts.slice(2)
      return extraBodyParts.join(', ')
    },
    getSpecialtyName(specialtyId) {
      const specialty = this.items.find((item) => item.specialityId === specialtyId)
      if (specialty && specialty.specialtyName) {
        return specialty.specialtyName
      }

      if (this.examDetails && this.examDetails.specialityId === specialtyId && this.examDetails.specialtyName) {
        return this.examDetails.specialtyName
      }

      const specialtyMap = {
        19: 'ELETROCARDIOGRAMA',
        25: 'RX',
        53: 'RX-OIT',
        20: 'ELETROENCEFALOGRAMA',
        22: 'ESPIROMETRIA',
        87: 'TOMOGRAFIA',
        109: 'RESSONANCIA',
        110: 'MAMOGRAFIA',
        113: 'DENSITOMETRIA',
        16: 'ACUIDADE',
        24: 'MAPA',
        99: 'ESFORCO_CARDIOPULMONAR',
        75: 'TESTE_ERGOMETRICO',
        160: 'RM-PUNHO ESQUERDO'
      }

      return specialtyMap[specialtyId] || `Specialty ${specialtyId}`
    },

    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
    clearForm() {
      this.reportStatus = ''
      this.repeat = false
      this.reportText = ''
      this.showEditButton = false
      this.showMasks = false
      this.showRetryButtonMasks = false
      this.isAbnormal = false
      this.selectedMasks = []
      this.selectedSpecialty = null
      this.showSpecialtyDropdown = false
      this.pastedText = false
      this.similarityUserDecisionMade = false
      this.lastSimilarityWarnedText = ''
      this.pendingGenderConfirmation = false
      this.pendingGenderConfirmationText = ''
      this.resetDivergences()
    },
    async fetchExamDetails(examId) {
      try {
        const details = await this.getDetails(examId)

        if (!details || this.examSelected !== examId) {
          return
        }

        this.examDetails = {
          ...details,
          examId: details.examId || examId,
          specialityId: details.specialityId || details.specialtyId || (details.specialty && details.specialty.id),
          examFiles: details.examFiles || []
        }

        if (details.labels && details.labels.length) {
          const exam = this.items.find((item) => item.examId === examId)
          if (exam) {
            this.$set(exam, 'labels', details.labels)
          }
        }

        if (this.examDetails.retification) {
          this.reportStatus = this.examDetails.isAlterado ? 'alterado' : 'normal'
          this.isTextareaDisabled = true
          this.reportText = this.examDetails.description
          this.isAbnormal = this.examDetails.isAlterado
          this.showMasks = true
        } else {
          this.isTextareaDisabled = false
        }
      } catch (error) {}
    },
    enableTextarea() {
      if (this.examDetails.retification) {
        this.isTextareaDisabled = false
        this.showEditButton = false
        this.showMaintainButton = false
        this.showSubmitButton = true
        this.isEditClicked = true
        this.isMaintainClicked = false
      }
    },
    handleMaintain() {
      if (this.examDetails.retification) {
        this.isTextareaDisabled = true
        this.showMaintainButton = false
        this.showEditButton = false
        this.showSubmitButton = true
        this.isMaintainClicked = true
        this.isEditClicked = false
      }
    },
    async fetchMasks(specialityId) {
      try {
        this.selectedSpecialtyId = specialityId
        this.showRetryButtonMasks = false
        this.masksLoading = true
        if (!specialityId) {
          return
        }
        this.showNoMasksMessage = false
        this.masks = []

        const response = await this.getMaskOptions(specialityId)
        if (!response?.data?.length) {
          this.showNoMasksMessage = true
        }

        const allMasks = response.data.map((mask) => ({
          id: mask.id,
          title: mask.name,
          content: mask.text,
          isActive: mask.isActive,
          specialityId: mask.specialityId,
          languageId: mask.languageId,
          isChanged: mask.isChanged
        }))

        this.masks = allMasks

        const uniqueSpecialties = [...new Set(allMasks.map((mask) => mask.specialityId))]
        this.specialties = uniqueSpecialties

        if (allMasks.length > 0) {
          this.autoSelectSpecialtyIfOnlyOne()
        }

        if (this.examDetails.retification && this.examDetails.specialityId) {
          this.selectedSpecialty = this.examDetails.specialityId
        }
      } catch (error) {
        this.masks = []
        this.showRetryButtonMasks = true
      } finally {
        this.masksLoading = false
      }
    },

    selectSpecialty(specialtyId) {
      this.selectedSpecialty = specialtyId
      this.showSpecialtyDropdown = false
    },

    toggleSpecialtyDropdown() {
      if (
        this.repeat ||
        this.reportStatus === 'alterado' ||
        (this.filteredSpecialties && this.filteredSpecialties.length === 1)
      ) {
        this.showSpecialtyDropdown = false
        return
      }
      this.showSpecialtyDropdown = !this.showSpecialtyDropdown
      if (this.showSpecialtyDropdown) {
        this.showMasks = true
      }
    },

    handleStatusChange(status) {
      this.reportStatus = status
      this.isAbnormal = status === 'alterado'
      if (status === 'alterado') {
        this.showSpecialtyDropdown = false
      }
      this.selectedSpecialty = null
      this.autoSelectSpecialtyIfOnlyOne()
      this.userDecisionMade = false
      this.lastValidatedText = ''
    },
    handleMaskSelection(mask) {
      const maskIndex = this.selectedMasks.findIndex((m) => m.id === mask.id)

      if (maskIndex === -1) {
        this.selectedMasks.push(mask)
        this.reportText = this.reportText ? `${this.reportText}\n${mask.content}` : mask.content
      } else {
        this.selectedMasks.splice(maskIndex, 1)

        const contentToRemove = mask.content

        if (this.reportText === contentToRemove) {
          this.reportText = ''
        } else if (this.reportText.endsWith(`\n${contentToRemove}`)) {
          this.reportText = this.reportText.replace(`\n${contentToRemove}`, '')
        } else if (this.reportText.includes(`${contentToRemove}\n`)) {
          this.reportText = this.reportText.replace(`${contentToRemove}\n`, '')
        } else {
          this.reportText = this.reportText.replace(contentToRemove, '')
        }
      }
    },

    checkAndDeselectMasks() {
      if (!this.selectedMasks.length) return

      const selectedMasksCopy = [...this.selectedMasks]

      for (const mask of selectedMasksCopy) {
        const contentExists = this.isMaskContentInReport(mask.content)

        if (!contentExists) {
          const maskIndex = this.selectedMasks.findIndex((m) => m.id === mask.id)
          if (maskIndex !== -1) {
            this.selectedMasks.splice(maskIndex, 1)
          }
        }
      }
    },

    isMaskContentInReport(content) {
      if (!content || !this.reportText) return false

      if (this.reportText.includes(content)) return true

      const normalizedReportText = this.reportText.replace(/\s+/g, ' ').trim()
      const normalizedContent = content.replace(/\s+/g, ' ').trim()

      return normalizedReportText.includes(normalizedContent)
    },
    removeDiacritics(text = '') {
      const safeText = String(text)
      try {
        return safeText.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      } catch (error) {
        return safeText
      }
    },
    escapeRegex(text = '') {
      const safeText = String(text)
      return safeText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    },
    renderCenteredTerms(list = []) {
      const joined = list.filter(Boolean).join(', ')
      return `<div style="text-align:center; margin:8px 0; font-weight:600;">${joined}</div>`
    },
    capitalize(text = '') {
      return text ? text.charAt(0).toUpperCase() + text.slice(1) : text
    },
    buildDivergenceMessage (divergences) {
      if (!divergences?.length) return ''

      const sections = divergences.map(d => {
        let html = ''
        if (d.intro) html += `<p style="margin:0 0 4px;">${d.intro}</p>`
        if (d.keywords?.length) {
          const items = d.keywords.map(k => `<li><b>${this.capitalize(k.word)}</b></li>`).join('')
          html += `<ul style="margin:4px 0 0;">${items}</ul>`
        }
        return `<div style="margin-bottom:10px;">${html}</div>`
      })

      const sep = '<hr style="border:0;border-top:1px solid #eee;margin:8px 0;">'
      const intro = divergences.length > 1
        ? `<p style="font-size:1.05rem;color:#555;margin-bottom:10px;">${this.$i18n.t('radio_report.unified_divergences_intro')}</p>`
        : ''
      const scrollStyle = divergences.length > 2 ? 'max-height:280px;overflow-y:auto;padding-right:4px;' : ''
      const body = `<div style="text-align:left;${scrollStyle}">${intro}${sections.join(sep)}</div>`
      const question = `<p style="font-size:1.05rem;margin-top:14px;font-weight:500;color:#333;">${this.$i18n.t('radio_report.review_text_question')}</p>`

      return `${body}${question}`
    },
    resetDivergences () {
      this.activeDivergences = []
      this.activeWarningCount = 0
      this.statusChangeRequired = false
      this.statusConflictKeywords = []
      this.statusConflictType = 0
      this.foundKeywords = []
      this.hasGenderConflict = false
      this.genderConflictExamGender = ''
      this.genderConflictKeywords = []
      this.hasLateralityConflict = false
      this.lateralityConflictSide = ''
      this.lateralityConflictKeywords = []
      this.hasBodyPartConflict = false
      this.bodyPartConflictKeywords = []
      this.bodyPartExpectedName = ''
      this.specialtyConflictKeywords = []
      this.conflictSpecialtyName = ''
      this.similarityWarningActive = false
    },
    setSpecialtyConflicts() {
      this.specialtyConflicts = SpecialtyConflicts
      const conflictIndexBySpecialityId = {}
      const conflictListBySpecialityId = this.specialtyConflicts?.pt?.conflicts

      if (Array.isArray(conflictListBySpecialityId)) {
        for (const conflictConfig of conflictListBySpecialityId) {
          if (!conflictConfig || typeof conflictConfig.specialityId !== 'number') {
            continue
          }

          conflictIndexBySpecialityId[conflictConfig.specialityId] = conflictConfig
        }
      }
      this.conflictIndexBySpeciality = conflictIndexBySpecialityId
    },
    normalizeGender(gender) {
      if (!gender) return null
      const g = gender.toString().toUpperCase().trim()
      if (g === 'FEMININO' || g === 'F') return 'F'
      if (g === 'MASCULINO' || g === 'M') return 'M'
      return null
    },
    setGenderExclusiveExams() {
      if (!GenderExclusiveExams) {
        return
      }
      this.genderExclusiveExams = GenderExclusiveExams
    },
    setLateralityExams() {
      if (!LateralityExams) {
        return
      }
      this.lateralityExams = LateralityExams
    },
    normalizeSpecialityId(specialityIdOrConstant) {
      if (typeof specialityIdOrConstant === 'number') {
        return specialityIdOrConstant
      }

      if (typeof specialityIdOrConstant === 'string') {
        const constantValue = CONSTANTS.SPECIALITY[specialityIdOrConstant]
        if (typeof constantValue === 'number') {
          return constantValue
        }
      }
      return specialityIdOrConstant
    },
    getExamSpecialityIdForConflict() {
      const subSpecialtyId = this.examDetails?.subSpecialty
      const specialityIdFromExamDetails = this.examDetails?.specialityId
      const specialityIdFromCurrentExam = this.currentExam?.specialityId
      const specialityIdFromSelection = this.selectedSpecialtyId

      return (
        subSpecialtyId ||
        specialityIdFromExamDetails ||
        specialityIdFromCurrentExam ||
        specialityIdFromSelection ||
        null
      )
    },
    detectStatusDivergence () {
      if (!this.reportText?.trim() || this.repeat) return null
      if (this.userDecisionMade && this.reportText === this.lastValidatedText) return null
      if (!this.reportKeywords) return null

      const conflict = findStatusConflict({
        reportText: this.reportText,
        status: this.reportStatus,
        reportKeywords: this.reportKeywords,
        normalStatusValue: 'normal',
        abnormalStatusValue: 'alterado'
      })
      if (!conflict) return null

      this.statusChangeRequired = true
      this.statusConflictKeywords = conflict.keywords
      this.foundKeywords = conflict.keywords

      const introKey = conflict.conflictType === 'normal_status_with_abnormal_text'
        ? 'radio_report.normal_status_with_abnormal_text_intro'
        : 'radio_report.abnormal_status_with_normal_text_intro'

      return {
        type: 'status',
        intro: this.$i18n.t(introKey),
        keywords: conflict.keywords
      }
    },
    collectKeywordsForSpecialty(specialityIdOrConstant) {
      const specialityId = this.normalizeSpecialityId(specialityIdOrConstant)
      const { keywords } = collectSpecialtyKeywords({ specialtyConflicts: this.specialtyConflicts, specialityId })

      return {
        keywords,
        name: this.getSpecialtyName(specialityId)
      }
    },
    detectSpecialtyDivergence (lateralityDiv, bodyPartDiv) {
      if (!this.reportText?.trim() || this.repeat) return null
      if (this.userDecisionMade && this.reportText === this.lastValidatedText) return null
      if (!this.specialtyConflicts) return null

      const examSpecialityId = this.getExamSpecialityIdForConflict()
      if (!examSpecialityId) return null

      const { keywords: conflictKeywords, name: conflictSpecialtyName } =
        this.collectKeywordsForSpecialty(examSpecialityId)
      if (!conflictKeywords?.length) return null

      const keywordMatches = findKeywordsInText(this.reportText, conflictKeywords, {
        specialityId: examSpecialityId,
        bodyPartsData: BodyParts
      })
      if (!keywordMatches.length) return null

      const lateralityWords = new Set((lateralityDiv?.keywords || []).map(k => (k.word || '').toLowerCase()))
      const bodyPartWords = new Set((bodyPartDiv?.keywords || []).map(k => (k.word || '').toLowerCase()))
      const filtered = keywordMatches.filter(k => !lateralityWords.has(k.word.toLowerCase()) && !bodyPartWords.has(k.word.toLowerCase()))
      if (!filtered.length) return null

      this.specialtyConflictKeywords = filtered
      this.conflictSpecialtyName = conflictSpecialtyName || ''

      return {
        type: 'specialty',
        intro: this.$i18n.t('radio_report.unified_specialty_conflict_intro', { specialty: `<b>${this.conflictSpecialtyName}</b>` }),
        keywords: filtered
      }
    },
    getCurrentPatientGender() {
      return this.normalizeGender(this.currentExam?.gender)
    },
    detectGenderDivergence () {
      const patientGender = this.getCurrentPatientGender()
      if (this.userDecisionMade && this.reportText === this.lastValidatedText) return null

      const conflict = findGenderConflict({
        // Specialty-based detection only applies before the user has decided.
        specialityId: this.userDecisionMade ? null : (this.currentExam?.specialityId || this.selectedSpecialty),
        patientGender,
        // Keyword-based detection is skipped while repeating an exam.
        reportText: this.repeat ? '' : this.reportText,
        genderExclusiveExams: this.genderExclusiveExams
      })
      if (!conflict.hasConflict) return null

      this.hasGenderConflict = true
      this.genderConflictExamGender = conflict.examGender
      if (conflict.source === 'keyword') this.genderConflictKeywords = conflict.keywords

      const genderLabel = (gender) => gender === 'F'
        ? this.$i18n.t('radio_report.gender_female')
        : this.$i18n.t('radio_report.gender_male')

      if (conflict.source === 'specialty') {
        return {
          type: 'gender',
          intro: this.$i18n.t('radio_report.gender_exam_conflict_intro', {
            examGender: `<b>${genderLabel(conflict.examGender)}</b>`,
            patientGender: `<b>${genderLabel(patientGender)}</b>`
          }),
          keywords: []
        }
      }

      let intro
      if (patientGender && conflict.examGender) {
        intro = this.$i18n.t('radio_report.unified_gender_keyword_intro', {
          examGender: genderLabel(conflict.examGender),
          patientGender: genderLabel(patientGender)
        })
      } else {
        intro = `<b>${this.$i18n.t('radio_report.unified_gender_label')}:</b>`
      }

      return { type: 'gender', intro, keywords: conflict.keywords }
    },
    detectLateralityDivergence () {
      if (this.userDecisionMade && this.reportText === this.lastValidatedText) return null
      if (!this.reportText?.trim() || this.repeat) return null

      const specialityId = this.currentExam?.specialityId || this.selectedSpecialty
      if (!specialityId) return null

      const result = checkLateralityConflict({
        specialityId,
        reportText: this.reportText,
        lateralityData: this.lateralityExams
      })

      if (!result.hasConflict) return null

      this.hasLateralityConflict = true
      this.lateralityConflictSide = result.examSide
      this.lateralityConflictKeywords = result.conflictKeywords

      const examSideLabel = result.examSide === 'left' ? this.$i18n.t('radio_report.laterality_left') : this.$i18n.t('radio_report.laterality_right')
      const oppositeSideLabel = result.examSide === 'left' ? this.$i18n.t('radio_report.laterality_right') : this.$i18n.t('radio_report.laterality_left')
      return {
        type: 'laterality',
        intro: this.$i18n.t('radio_report.unified_laterality_conflict_intro', { examSide: `<b>${examSideLabel}</b>`, oppositeSide: `<b>${oppositeSideLabel}</b>` }),
        keywords: result.conflictKeywords
      }
    },
    detectBodyPartDivergence () {
      if (this.userDecisionMade && this.reportText === this.lastValidatedText) return null
      if (this.repeat) return null

      const examName = this.currentExam?.specialtyName ||
        this.getSpecialtyName(this.currentExam?.specialityId) || ''

      const specialityId = this.currentExam?.specialityId || this.selectedSpecialty
      const conflict = findBodyPartConflict({
        examName,
        reportText: this.reportText,
        specialityId,
        bodyPartsData: BodyParts
      })
      if (!conflict.hasConflict) return null

      this.bodyPartExpectedName = conflict.expectedBases.map((b) => this.capitalize(b)).join(', ')
      this.hasBodyPartConflict = true
      this.bodyPartConflictKeywords = conflict.conflictKeywords

      return {
        type: 'bodypart',
        intro: this.$i18n.t('radio_report.unified_bodypart_conflict_intro', { expected: `<b>${this.bodyPartExpectedName}</b>` }),
        keywords: conflict.conflictKeywords
      }
    },
    collectDivergences () {
      this.resetDivergences()

      const statusDiv = this.detectStatusDivergence()
      const genderDiv = this.detectGenderDivergence()
      const lateralityDiv = this.detectLateralityDivergence()
      const bodyPartDiv = this.detectBodyPartDivergence()
      const specialtyDiv = this.detectSpecialtyDivergence(lateralityDiv, bodyPartDiv)
      const similarityDiv = this.detectSimilarityDivergence()

      this.activeDivergences = [statusDiv, genderDiv, lateralityDiv, bodyPartDiv, specialtyDiv, similarityDiv].filter(Boolean)
      this.activeWarningCount = this.activeDivergences.length

      return this.activeDivergences
    },
    captureTriggeredCheckResults (divergences = this.activeDivergences) {
      this.lastTriggeredCheckResults = this.buildCheckResults(
        divergences,
        this.similarityMatchPercentage,
        this.bodyPartConflictKeywords,
        this.alertReviewedFlags
      )
      return this.lastTriggeredCheckResults
    },
    getConflictingGenderForSpecialty(specialityId) {
      return getConflictingGenderForSpecialty({ specialityId, genderExclusiveExams: this.genderExclusiveExams })
    },
    normalizeReportText (text = '') {
      return String(text)
        .replace(/\r\n|\r/g, '\n')
        .replace(/[ \t]+/g, ' ')
        .replace(/\n+/g, '\n')
        .trim()
    },
    getReportHistory () {
      try {
        const storageKey = this.STORAGE_KEY_SIMILARITY
        const storedValue = localStorage.getItem(storageKey)
        const parsedValue = JSON.parse(storedValue || '[]')
        return Array.isArray(parsedValue) ? parsedValue : []
      } catch (error) {
        return []
      }
    },
    saveReportHistory (historyList = []) {
      const storageKey = this.STORAGE_KEY_SIMILARITY
      localStorage.setItem(storageKey, JSON.stringify(historyList))
    },
    addReportToHistory (reportText = '') {
      if (!this.canValidateReportSimilarity()) return

      const normalizedText = this.normalizeReportText(reportText)
      if (!normalizedText) return

      const currentHistory = this.getReportHistory()
      const updatedHistory = [normalizedText, ...currentHistory].slice(0, this.MAX_REPORTS_HISTORY)

      this.saveReportHistory(updatedHistory)
    },
    calculateSimilarityScore (textA = '', textB = '') {
      const normalizedA = this.normalizeReportText(textA)
      const normalizedB = this.normalizeReportText(textB)

      if (!normalizedA && !normalizedB) return 1
      if (!normalizedA || !normalizedB) return 0

      return stringSimilarity(normalizedA, normalizedB)
    },
    detectSimilarityDivergence () {
      if (!this.canValidateReportSimilarity()) {
        this.similarityMatchPercentage = 0
        this.similarityWarningActive = false
        this.lastSimilarityWarnedText = ''
        this.similarityUserDecisionMade = false
        return null
      }

      if (!this.pastedText) return null

      const normalizedReportText = this.normalizeReportText(this.reportText)
      if (this.similarityUserDecisionMade && normalizedReportText === this.lastSimilarityWarnedText) return null

      const reportHistoryList = this.getReportHistory()
      if (!normalizedReportText || !reportHistoryList.length) return null

      let highestScore = 0
      for (const saved of reportHistoryList) {
        const score = this.calculateSimilarityScore(normalizedReportText, saved)
        if (score > highestScore) highestScore = score
      }

      if (highestScore < this.SIMILARITY_THRESHOLD) return null

      const percent = Math.round(highestScore * 100)
      this.similarityMatchPercentage = percent
      this.similarityWarningActive = true
      this.lastSimilarityWarnedText = normalizedReportText

      return {
        type: 'similarity',
        intro: `<b>${this.$i18n.t('radio_report.unified_similarity_label')}:</b> ${this.$i18n.t('radio_report.unified_similarity_detail', { percentage: percent })}`,
        keywords: []
      }
    },
    handleReportPaste (event) {
      const pastedText = event?.clipboardData?.getData('text') || ''
      if (!pastedText) return

      this.pastedText = true
      this.similarityUserDecisionMade = false
    },
    isXrayCategory () {
      return this.currentExam.linkCLientId.toLowerCase().trim() === 'raiox'
    },
    canValidateReportSimilarity () {
      return Boolean(this.examDetails.enableSimilarityCheck) && !this.isXrayCategory()
    },
    async handleForm(options = {}) {
      try {
        if (this.userDecisionMade && this.reportText !== this.lastValidatedText) {
          this.userDecisionMade = false
        }

        const specialityId = this.currentExam?.specialityId
        const abriuExame = localStorage.getItem('laudo_abriu_exame') === 'true'
        const abriuObs = localStorage.getItem('laudo_abriu_observacao') === 'true'

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'click_laudar_tracked_v2',
          click_text: 'Laudar',
          button_id: 'laudar',
          page_path: window.location.pathname,
          specialty_id: specialityId,
          abriu_exame: abriuExame,
          abriu_observacao: abriuObs,
          abriu_alguma_coisa: abriuExame || abriuObs
        })

        localStorage.removeItem('laudo_abriu_exame')
        localStorage.removeItem('laudo_abriu_observacao')

        const checkResultsFromConfirm = options.checkResults || null
        if (!checkResultsFromConfirm) {
          const divergences = this.collectDivergences()
          if (divergences.length > 0) {
            this.captureTriggeredCheckResults(divergences)
            this.showDialog = 10
            return
          }
        }

        if (this.isSubmittingReport) return
        this.isSubmittingReport = true

        try {
          if (this.repeat) {
            await this.examRepeatRadio(this.currentExam.examId, this.reportText)
          } else {
            const checkResults = checkResultsFromConfirm
              || this.pendingCheckResults
              || this.buildCheckResults([], 0, [], this.alertReviewedFlags)
            await this.sendReportRadio(this.currentExam.examId, {
              reportText: sanitizeReportText(this.reportText),
              abnormal: this.reportStatus === 'alterado',
              fullAbdomen: this.isFullAbdomen,
              obsViewed: this.obsViewed,
              edited: this.isEditClicked,
              pastedText: this.pastedText,
              reportCorrectionNotice: this.currentExam.reportCorrectionNotice || null,
              status: this.currentExam.status ?? null,
              checkResults
            })
          }
          this.addReportToHistory(this.reportText)

          this.userDecisionMade = false
          this.lastValidatedText = ''
          this.resetAlertAuditState()

          this.resetForm()

          await this.load()

          this.$nextTick(() => {
            if (this.sortedItems.length > 0) {
              this.selectExam(this.sortedItems[0].examId)
            }
          })

          this.showFeedback()
        } finally {
          this.isSubmittingReport = false
        }
      } catch (error) {
        this.$root.$emit('toast', {
          message: this.$i18n.t('radio_report.error_sending_report'),
          type: 'error'
        })
      }
    },
    toggleReportStatus(status) {
      if (this.reportStatus === status) {
        this.reportStatus = ''
        this.showMasks = false
        this.showSpecialtyDropdown = false
        this.selectedSpecialty = null
        this.selectedMasks = []
      } else {
        this.handleStatusChange(status)
      }
      if (this.repeat) {
        this.repeat = false
      }
    },
    autoSelectSpecialtyIfOnlyOne() {
      if (this.filteredSpecialties && this.filteredSpecialties.length === 1) {
        this.selectSpecialty(this.filteredSpecialties[0])
        this.showMasks = true
      }
    },
    examSorter(a, b) {
      const aHasRetification = this.hasRetification(a)
      const bHasRetification = this.hasRetification(b)
      if (aHasRetification !== bHasRetification) {
        return bHasRetification - aHasRetification
      }

      if (a.emergency !== b.emergency) {
        return b.emergency - a.emergency
      }

      if (a.urgent !== b.urgent) {
        return b.urgent - a.urgent
      }

      if (!!a.comment !== !!b.comment) {
        return !!b.comment - !!a.comment
      }
      return new Date(a.openingDate) - new Date(b.openingDate)
    },
    async load() {
      this.isLoading = true
      this.hasLoaded = false
      try {
        let items = await this.getRadioExamsList()

        if (items && items.length > 0) {
          this.hasNoExamsAvailable = false
          items = items.sort(this.examSorter)

          items = items.map((item) => {
            if (item.series && Array.isArray(item.series)) {
              item.bodyParts = item.series
            } else {
              item.bodyParts = []
            }

            if (!item.patientName || item.patientName.trim() === '') {
              console.warn(`Exam ${item.examId} missing patientName, using fallback`)
              item.patientName = `Patient ${item.examId}`
            }

            item.truncatedPatientName = this.truncatePatientName(item.patientName)
            item.gender = this.normalizeGender(item.gender)

            return item
          })

          this.items = items
          this.lastUpdated = new Date()

          if (this.query) {
            this.filterItems()
          } else {
            this.filteredItems = [...this.items]
          }

          this.hasLoaded = true

          await this.$nextTick()
          this.reorderItems()

          if (this.filteredItems.length > 0) {
            const firstExamId = this.filteredItems[0].examId
            await this.selectExam(firstExamId)
            this.stopTimer()
            this.stopBaseItemTimer()
          } else {
            this.isTimerActive = true
            this.startTimer()
            this.startBaseItemTimer()
          }
        } else {
          console.warn('No exam items received from API')
          this.hasNoExamsAvailable = true
          this.hasActivitySinceLastHeartbeat = true
          this.sendPhysicianHeartbeat()
          this.items = []
          this.filteredItems = []
          this.examSelected = null
          this.resetForm()
          this.hasLoaded = true
          this.isTimerActive = true
          this.startTimer()
          this.startBaseItemTimer()
        }
      } catch (error) {
        console.error('Erro ao carregar exames:', error)
      } finally {
        this.isLoading = false
      }
    },
    startTimer() {
      if (this.interval) return
      this.interval = setInterval(async () => {
        await this.load()
      }, 30000)
    },
    stopTimer() {
      clearInterval(this.interval)
      this.interval = null
    },
    startBaseItemTimer() {
      if (this.baseItemInterval) return
      this.baseItemInterval = setInterval(async () => {
        await this.fetchBaseItemAndReloadQueue()
      }, 30000)
    },
    stopBaseItemTimer() {
      clearInterval(this.baseItemInterval)
      this.baseItemInterval = null
    },
    resetRadioMaskButtons() {
      this.abnormal = null
      if (this.$refs.radioMask) {
        this.$refs.radioMask.resetButtons()
      }
    },
    handleRefreshConfirmation() {
      if (this.reportText.length > 0) {
        this.showDialog = 2
        return
      }
      return this.handleRefresh()
    },
    async handleRefresh() {
      try {
        const items = await this.getRadioExamsList()

        if (items && items.length > 0) {
          this.items = items.map((item) => {
            if (item.series && Array.isArray(item.series)) {
              item.bodyParts = item.series
            } else {
              item.bodyParts = []
            }

            if (!item.patientName || item.patientName.trim() === '') {
              console.warn(`Refresh: Exam ${item.examId} missing patientName, using fallback`)
              item.patientName = `Patient ${item.examId}`
            }

            item.truncatedPatientName = this.truncatePatientName(item.patientName)
            item.gender = this.normalizeGender(item.gender)

            return item
          })

          this.lastUpdated = new Date()
          this.filterItems()
          this.reorderItems()

          if (this.sortedItems.length > 0) {
            await this.selectExam(this.sortedItems[0].examId)
          }

          this.$root.$emit('toast', {
            message: this.$i18n.t('radio_report.exams_list_updated'),
            type: 'success'
          })
        } else {
          console.warn('No exam items received during refresh')
        }
      } catch (error) {
        console.error('Error refreshing exams:', error)
      }
    },
    async refreshAfterSendInformation() {
      await this.load()

      if (this.sortedItems.length > 0) {
        this.selectExam(this.sortedItems[0].examId)
      }
    },
    filterItems() {
      this.filteredItems = this.items
        .filter(
          (item) =>
            item.patientName.toLowerCase().includes(this.query.toLowerCase()) ||
            item.examId.toString().includes(this.query) ||
            item.specialtyName.toLowerCase().includes(this.query.toLowerCase())
        )
        .map((item) => {
          item.truncatedPatientName = this.truncatePatientName(item.patientName)
          return item
        })

      this.reorderItems()

      if (!this.currentExam) {
        this.isTimerActive = true
        this.startTimer()
      }
    },
    handleRowSelected(examId) {
      this.isSourceHighComplexity(examId)
      if (this.examSelected === examId) {
        return
      }
      this.resetPreviousExamsAccordion()
      if (this.reportText.trim().length > 0) {
        this.showDialog = 1
        this.nextExamId = examId
      } else {
        this.selectExam(examId)
      }
      this.isEditClicked = false
    },
    handleCloseComment() {
      this.viewingComment = false
    },
    handleCloseObservation() {
      this.viewingObservation = false
    },
    reorderItems() {
      this.filteredItems = [...this.filteredItems].sort(this.examSorter)
    },
    async handleTitleReport(examId) {
      const currentExam = examId ? this.items.find((item) => item.examId === examId) : null
      if (!currentExam) return

      const apiTitle = currentExam.titleReport
      const series = currentExam.series || []
      const titleParts = apiTitle ? this.splitTitleReport(apiTitle) : []
      const potentialTitle = titleParts.length > 0 ? titleParts[0].trim() : (series[0] || '').trim()

      if (potentialTitle && Array.isArray(this.subSpecialties)) {
        const matched = this.subSpecialties.find((sub) => sub.name.toLowerCase() === potentialTitle.toLowerCase())

        if (matched) {
          this.examDetails.subSpecialty = matched.specialityId
          this.selectedSpecialtyId = matched.specialityId
          await this.fetchMasks(matched.specialityId)
          return
        }
      }

      if (potentialTitle && BodyParts && Array.isArray(BodyParts)) {
        const found = BodyParts.find(
          (bp) =>
            bp.synonyms?.some((s) => s.toLowerCase() === potentialTitle.toLowerCase()) ||
            bp.norm?.toLowerCase() === potentialTitle.toLowerCase()
        )

        if (found?.specialityId) {
          this.selectedSpecialtyId = found.specialityId
          await this.fetchMasks(found.specialityId)
          return
        }
      }

      if (currentExam.specialityId) {
        this.selectedSpecialtyId = currentExam.specialityId
        await this.fetchMasks(currentExam.specialityId)
      }
    },
    async selectExam(examId) {
      this.resetForm()
      if (!examId) {
        console.warn('Attempted to select exam with null or undefined ID')
        return
      }

      this.pinnedExam = examId
      this.examSelected = examId

      const selectedExam = this.items.find((item) => item.examId === examId)

      if (selectedExam) {
        await this.handleGetListSpecialties(selectedExam.specialityId, selectedExam.sourceId)
        this.handleTitleReport(examId)
        if (!selectedExam.patientName || selectedExam.patientName.trim() === '') {
          try {
            const details = await this.getDetails(examId)
            if (details && details.patientName) {
              selectedExam.patientName = details.patientName
              selectedExam.truncatedPatientName = this.truncatePatientName(details.patientName)
            }
          } catch (error) {
            console.error('Error fetching exam details:', error)
          }
        }
      } else {
        console.warn('Selected exam not found in items list')
      }

      this.isSourceHighComplexity(examId)
      this.showEditButton = this.examDetails && this.examDetails.retification

      await this.$nextTick()
    },
    resetForm() {
      this.reportStatus = ''
      this.repeat = false
      this.reportText = ''
      this.isAbnormal = false
      this.selectedMasks = []
      this.selectedSpecialty = null
      this.showSpecialtyDropdown = false
      this.userDecisionMade = false
      this.lastSimilarityWarnedText = ''
      this.similarityUserDecisionMade = false
      this.pendingGenderConfirmation = false
      this.pendingGenderConfirmationText = ''
      this.pastedText = false
      this.obsViewed = false
      this.showNoMasksMessage = false
      this.selectedSpecialtyId = null
      this.showRetryButtonMasks = false
      this.masksLoading = false
      this.masks = []
      this.resetDivergences()
      this.resetAlertAuditState()
      this.resetRadioMaskButtons()
    },
    handleRepeatChange() {
      if (this.repeat) {
        this.reportStatus = ''
        this.showSpecialtyDropdown = false
        this.autoSelectSpecialtyIfOnlyOne()
      }
    },
    clearReportData() {
      this.description = ''
      if (this.$refs.report) {
        this.$refs.report.clear()
      }
    },
    collectBodyPartsDetected (divergences, bodyPartConflictKeywords) {
      const uniqueDetectedParts = []
      const seenNormalizedParts = new Set()
      const addDetectedPart = (rawValue) => {
        const normalizedPart = (rawValue || '').toString().trim()
        if (!normalizedPart || seenNormalizedParts.has(normalizedPart)) return
        seenNormalizedParts.add(normalizedPart)
        uniqueDetectedParts.push(normalizedPart)
      }
      for (const d of divergences || []) {
        if ((d.type === 'laterality' || d.type === 'specialty' || d.type === 'bodypart') && Array.isArray(d.keywords)) {
          for (const k of d.keywords) {
            if (k && typeof k === 'object' && k.bodyPart && k.word) {
              addDetectedPart(`${k.bodyPart}: ${k.word}`)
            } else {
              addDetectedPart(k.word || k)
            }
          }
        }
      }
      for (const row of bodyPartConflictKeywords || []) {
        if (row.bodyPart && row.word) {
          addDetectedPart(`${row.bodyPart}: ${row.word}`)
        } else {
          addDetectedPart(row.word || row.bodyPart)
        }
      }
      return uniqueDetectedParts
    },
    getAlertTypesFromDivergences (divergences = []) {
      const types = new Set((divergences || []).map((d) => d.type))
      return {
        similarity: types.has('similarity'),
        gender: types.has('gender'),
        bodyParts: types.has('laterality') || types.has('bodypart') || types.has('specialty')
      }
    },
    markAlertsAsReviewed (divergences = []) {
      const alertTypes = this.getAlertTypesFromDivergences(divergences)
      this.alertReviewedFlags = {
        similarity: this.alertReviewedFlags.similarity || alertTypes.similarity,
        gender: this.alertReviewedFlags.gender || alertTypes.gender,
        bodyParts: this.alertReviewedFlags.bodyParts || alertTypes.bodyParts
      }
    },
    markAlertsAsReviewedFromCheckResults (checkResults = {}) {
      this.alertReviewedFlags = {
        similarity: this.alertReviewedFlags.similarity || Boolean(checkResults.similarity?.similarityAlert),
        gender: this.alertReviewedFlags.gender || Boolean(checkResults.gender?.genderAlert),
        bodyParts: this.alertReviewedFlags.bodyParts || Boolean(checkResults.bodyParts?.bodyPartsAlert)
      }
    },
    resetAlertAuditState () {
      this.pendingCheckResults = null
      this.lastTriggeredCheckResults = null
      this.alertReviewedFlags = {
        similarity: false,
        gender: false,
        bodyParts: false
      }
    },
    buildCheckResults (divergences, similarityPercent, bodyPartConflictKeywords, reviewedFlags = {}) {
      const alertTypes = this.getAlertTypesFromDivergences(divergences)
      const history = this.lastTriggeredCheckResults || {}
      const historicalSimilarityAlert = Boolean(history.similarity?.similarityAlert)
      const historicalGenderAlert = Boolean(history.gender?.genderAlert)
      const historicalBodyPartsAlert = Boolean(history.bodyParts?.bodyPartsAlert)
      const historicalPercent = history.similarity?.similarityPercentCheck || 0
      const historicalDetected = Array.isArray(history.bodyParts?.bodyPartsDetected)
        ? history.bodyParts.bodyPartsDetected
        : []
      const currentDetected = alertTypes.bodyParts
        ? this.collectBodyPartsDetected(divergences, bodyPartConflictKeywords)
        : []

      // Após review, preserva os alertas e o contexto histórico para auditoria
      const similarityAlert = alertTypes.similarity || historicalSimilarityAlert
      const genderAlert = alertTypes.gender || historicalGenderAlert
      const bodyPartsAlert = alertTypes.bodyParts || historicalBodyPartsAlert

      return {
        similarity: {
          similarityAlert,
          similarityPercentCheck: similarityAlert
            ? (similarityPercent || historicalPercent || 0)
            : historicalPercent,
          similarityAlertReviewed: Boolean(reviewedFlags.similarity)
        },
        gender: {
          genderAlert,
          genderAlertReviewed: Boolean(reviewedFlags.gender)
        },
        bodyParts: {
          bodyPartsAlert,
          bodyPartsDetected: bodyPartsAlert
            ? (currentDetected.length ? currentDetected : historicalDetected)
            : historicalDetected,
          bodyPartsAlertReviewed: Boolean(reviewedFlags.bodyParts)
        }
      }
    },
    buildConfirmedCheckResults () {
      // Confirmar envia os alertas ativos; *Reviewed só fica true se veio de um Revisar anterior
      const triggered = this.lastTriggeredCheckResults
        || this.buildCheckResults(
          this.activeDivergences,
          this.similarityMatchPercentage,
          this.bodyPartConflictKeywords,
          this.alertReviewedFlags
        )

      return {
        similarity: {
          ...triggered.similarity,
          similarityAlertReviewed: Boolean(this.alertReviewedFlags.similarity)
        },
        gender: {
          ...triggered.gender,
          genderAlertReviewed: Boolean(this.alertReviewedFlags.gender)
        },
        bodyParts: {
          ...triggered.bodyParts,
          bodyPartsAlertReviewed: Boolean(this.alertReviewedFlags.bodyParts)
        }
      }
    },
    sendWithoutReview() {
      if (this.showDialog === 10) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'radio_report_confirm_click',
          action: 'confirm',
          label: 'Confirmar',
          showDialog: this.showDialog
        })

        const checkResults = this.buildConfirmedCheckResults()
        this.pendingCheckResults = checkResults

        this.userDecisionMade = true
        this.lastValidatedText = this.reportText
        if (this.similarityWarningActive) {
          this.similarityUserDecisionMade = true
          this.lastSimilarityWarnedText = this.normalizeReportText(this.reportText)
        }
        this.showDialog = 0
        this.resetDivergences()
        this.handleForm({ checkResults })
        return
      }

      if (this.showDialog === 1) {
        this.clearForm()
        this.resetPreviousExamsAccordion()
        this.selectExam(this.nextExamId)
        this.nextExamId = null
      } else if (this.showDialog === 3) {
        this.handleDuplicateExam()
      } else {
        this.handleRefresh()
      }
      this.showDialog = 0
      this.resetDivergences()
    },
    reviewReport() {
      if (this.showDialog === 10) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'radio_report_review_click',
          action: 'review',
          label: 'Revisar',
          showDialog: this.showDialog
        })

        if (!this.lastTriggeredCheckResults && this.activeDivergences?.length) {
          this.captureTriggeredCheckResults(this.activeDivergences)
        }
        if (this.lastTriggeredCheckResults) {
          this.markAlertsAsReviewedFromCheckResults(this.lastTriggeredCheckResults)
        } else {
          this.markAlertsAsReviewed(this.activeDivergences)
        }
        // Mantém lastTriggeredCheckResults (percentual e bodyPartsDetected) para auditoria no envio
        this.pendingCheckResults = null
        this.showDialog = 0
        this.resetDivergences()
        this.userDecisionMade = false
        this.lastValidatedText = ''
        this.similarityUserDecisionMade = false
        this.lastSimilarityWarnedText = ''
        return
      }

      if (this.showDialog === 1) {
        this.nextExamId = null
      }
      this.showDialog = 0
      this.resetDivergences()
    },
    async handleViewObservation(item) {
      this.examSelected = item.examId
      this.currentExam.notes = await this.getExamNotes(item.examId)
      this.viewingObservation = true
      this.obsViewed = true
      localStorage.setItem('laudo_abriu_observacao', 'true') // MÉTRICA GTM + GA4
    },
    onChangeStatus(abnormal) {
      this.abnormal = abnormal
    },
    changeDescription(newDescription) {
      this.description = newDescription
    },
    showFeedback() {
      this.$root.$emit('toast', {
        message: this.$i18n.t('radio_report.successfully_sent'),
        type: 'success'
      })

      this.$nextTick(() => {
        if (this.sortedItems.length > 0) {
          this.selectExam(this.sortedItems[0].examId)
        }
      })

      this.examSelected = null
      this.description = ''
      this.abnormal = null
      this.isReadOnly = false

      if (this.$refs.report) {
        this.$refs.report.clear()
      }
    },
    truncatePatientName(name, maxLength = 23) {
      if (name.length <= maxLength) return name

      const nameParts = name.split(' ')
      let truncatedName = nameParts[0]

      for (let i = 1; i < nameParts.length; i++) {
        if ((truncatedName + ' ' + nameParts[i]).length > maxLength) {
          truncatedName += '...'
          break
        }
        truncatedName += ' ' + nameParts[i]
      }
      return truncatedName
    },
    isSourceHighComplexity(examId) {
      this.isExamHighComplexity = false
      const examSelected = this.items.find((item) => item.examId === examId)
      this.isExamHighComplexity = examSelected?.highComplexity
    },
    getColorClass(confidence) {
      if (confidence == null || confidence === undefined) return 'color-gray'
      if (confidence >= 90) return 'color-green'
      if (confidence >= 70) return 'color-yellow'
      return 'color-red'
    },
    async togglePreviousAccordion() {
      this.isPreviousAccordionOpen = !this.isPreviousAccordionOpen

      if (this.isPreviousAccordionOpen && this.examSelected) {
        await this.loadPreviousExams(this.examSelected)
      }
      if (!this.isPreviousAccordionOpen) {
        this.previousExamSearched = false
      }
    },
    async fetchPreviousExams() {
      if (this.showAdvancedSearch) return
      const cpf = this.cpfSearch.trim()
      if (!/^\d{11}$/.test(cpf)) {
        this.previousExams = []
        this.previousExamSearched = true
        return
      }
      try {
        this.previousExams = await this.getFreeFilteredExams({ document: cpf }, this.examSelected)
      } catch (error) {
        this.previousExams = []
      } finally {
        this.previousExamSearched = true
      }
    },
    async handleAdvancedSearch() {
      const { name, dateOfBirth, gender } = this.advancedSearch
      const examId = this.examSelected
      try {
        this.previousExams = await this.getFreeFilteredExams(
          {
            name,
            dateOfBirth: dateOfBirth?.replace(/\//g, '-'),
            gender
          },
          examId
        )
      } catch (error) {
        this.previousExams = []
      } finally {
        this.previousExamSearched = true
      }
    },
    resetAdvancedSearch() {
      this.showCpfSearch = false
      this.cpfSearch = ''
      this.advancedSearch = {
        name: '',
        dateOfBirth: '',
        gender: ''
      }
      this.advancedSearchErrors = {
        name: false
      }
      this.previousExams = []
      this.previousExamSearched = false
    },
    toggleCpfSearch(value) {
      this.showCpfSearch = value
      this.previousExams = []
      this.previousExamSearched = false
      if (!value) {
        this.cpfSearch = ''
      }
    },
    validateAndSearchAdvanced() {
      this.advancedSearchErrors.name = false
      if (!this.advancedSearch.name.trim()) {
        this.advancedSearchErrors.name = true
        return
      }
      this.handleAdvancedSearch()
    },
    async loadPreviousExams(examId) {
      if (!examId) return

      try {
        const exams = await this.getPreviousExamsByExamId(examId)
        this.previousExams = exams || []
      } catch (error) {
        console.error('Erro ao buscar exames anteriores:', error)
        this.previousExams = []
      } finally {
        this.previousExamSearched = true
        await this.$nextTick()
      }
    },
    extractFreeFilters() {
      const input = this.previousExamSearchId.trim()
      const parts = input.split(/\s+/)

      const document = parts.find((p) => /^\d{11}$/.test(p)) || ''
      const dateOfBirth = parts.find((p) => /^\d{2}[-/]\d{2}[-/]\d{4}$/.test(p))?.replace(/\//g, '-') || ''
      const gender = parts.find((p) => /^(m|f)$/i.test(p))?.toUpperCase() || ''

      const name =
        parts
          .filter((p) => !/^\d{11}$/.test(p) && !/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(p) && !/^(m|f)$/i.test(p))
          .join(' ') || ''

      return {
        name,
        dateOfBirth,
        document,
        gender
      }
    },
    openDicomViewer(url) {
      window.open(url, '_blank')
    },
    openReport(examId) {
      const exam = this.previousExams.find((e) => e.examId === examId)
      const url = exam?.reportURL
      if (url) {
        window.open(url, '_blank')
      }
    },
    formatDate(date) {
      if (!date) return ''
      return this.$moment(date).format('DD/MM/YYYY HH:mm')
    },

    formatDateBirth(date) {
      if (!date) return ''
      return this.$moment(date).format('DD/MM/YYYY')
    },
    resetPreviousExamsAccordion() {
      this.isPreviousAccordionOpen = false
      this.previousExamSearchId = ''
      this.resetAdvancedSearch()
    },
    async openFile(fileId) {
      try {
        this.$root.$emit('showLoading')

        const file = this.examDetails.examFiles.find((file) => file.examFileId === fileId)
        const extension = file ? file.extension.toLowerCase() : ''
        const fileName = file?.fileName || `file-${fileId}.${extension || 'unknown'}`

        let mimeType = 'application/octet-stream'
        if (extension === 'pdf') {
          mimeType = 'application/pdf'
        } else if (['png', 'jpg', 'jpeg', 'gif'].includes(extension)) {
          mimeType = `image/${extension === 'jpg' ? 'jpeg' : extension}`
        }

        try {
          const blobUrl = await this.getExamFileById(fileId, mimeType)

          if (!blobUrl) {
            throw new Error('Failed to retrieve file data')
          }

          if (extension === 'pdf') {
            window.open(blobUrl, '_blank')
          } else {
            const link = document.createElement('a')
            link.href = blobUrl
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        } catch (innerError) {
          console.error('Error with primary file handling method:', innerError)

          try {
            const response = await fetch(`/core/Administrator/Exams/File?examFileId=${fileId}`, {
              headers: {
                Accept: mimeType,
                Authorization: this.getFromLocalStorage('user')?.token
              }
            })

            if (!response.ok) {
              throw new Error(`Server responded with ${response.status}: ${response.statusText}`)
            }

            const blob = await response.blob()

            const url = URL.createObjectURL(new Blob([blob], { type: mimeType }))

            if (extension === 'pdf') {
              window.open(url, '_blank')
            } else {
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', fileName)
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)

              setTimeout(() => {
                URL.revokeObjectURL(url)
              }, 100)
            }
          } catch (fallbackError) {
            console.error('Fallback method also failed:', fallbackError)
            throw innerError
          }
        }
      } catch (error) {
        console.error('Error opening file:', error)
        this.$root.$emit('toast', {
          message: this.$i18n.t('radio_report.error_opening_file'),
          type: 'error'
        })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    sendShowDialogModalEvent(showDialogValue) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'radio_report_modal_show',
        showDialog: showDialogValue
      })
    },
    async handleOpenXView(examId) {
      localStorage.setItem('laudo_abriu_exame', 'true') // MÉTRICA GTM + GA4

      if (this.isOpeningXView) return
      this.isOpeningXView = true

      const popup = window.open('about:blank', '_blank')

      this.$root.$emit('showLoading')
      try {
        const result = await this.getExamXView(examId)
        const examURL = result?.exameURL
        if (!examURL) {
          if (popup) popup.close()
          this.$toast.error(this.$t('no_exams'))
          return
        }
        if (popup) {
          popup.location.href = examURL
        } else {
          window.location.assign(examURL)
        }
      } catch (err) {
        if (popup) popup.close()
        this.$toast.error(this.$t('unexpected_error_occurred'))
      } finally {
        this.$root.$emit('hideLoading')
        this.isOpeningXView = false
      }
    },
    handleCustomViewer(studyInstanceUid) {
      localStorage.setItem('laudo_abriu_exame', 'true') // MÉTRICA GTM + GA4
      window.location.href = `${import.meta.env.VITE_URL_PIXEON}${studyInstanceUid}`
    },
    getAttachmentTypeName(attachmentTypeId) {
      const attachmentType = this.attachmentTypes.find((type) => type.id === attachmentTypeId)
      return attachmentType ? attachmentType.description : this.$t('radio_report.document')
    },
    async handleLoadExams () {
      if (this.isLoadingExamsQueue) return

      this.isLoadingBaseItem = true

      try {
        const baseItemResponse = await this.getBaseItemForFastReport()
        const baseItemData = baseItemResponse?.data?.data

        const hasExamId = Boolean(baseItemData?.examId)
        if (!hasExamId) {
          const message = this.$t('radio_report.load_exams_empty')
          this.$root.$emit('toast', { message, type: 'warning' })
          return
        }
        await this.load()
        this.$root.$emit('toast', { message: this.$t('radio_report.load_exams_success'), type: 'success' })
      } catch (error) {
        const apiMessage = error?.response?.data?.errors?.[0]?.message
        const message = apiMessage || this.$t('radio_report.load_exams_error')
        this.$root.$emit('toast', { message, type: 'error' })
      } finally {
        this.isLoadingBaseItem = false
      }
    },
    async fetchBaseItemAndReloadQueue() {
      if (this.isLoadingExamsQueue) return

      this.isLoadingExamsQueue = true

      try {
        const baseItemResponse = await this.getBaseItemForFastReport()
        const baseItemData = baseItemResponse?.data?.data

        const hasExamId = Boolean(baseItemData?.examId)
        if (!hasExamId) return

        await this.load()
      } catch (error) {
      } finally {
        this.isLoadingExamsQueue = false
      }
    },
    startPhysicianHeartbeat () {
      if (!this.isHeartbeatRouteEligible() || this.heartbeatInterval) {
        return
      }

      this.registerHeartbeatListeners()
      this.heartbeatInterval = setInterval(() => {
        this.sendPhysicianHeartbeat()
      }, HEARTBEAT_INTERVAL_IN_MILLISECONDS)
    },
    stopPhysicianHeartbeat () {
      clearInterval(this.heartbeatInterval)
      this.heartbeatInterval = null
      this.unregisterHeartbeatListeners()
      this.hasActivitySinceLastHeartbeat = false
      this.lastActivityAt = null
    },
    registerHeartbeatListeners () {
      if (this.heartbeatListenersRegistered) {
        return
      }

      this.getHeartbeatListeners().forEach(({ eventName, handler }) => {
        document.addEventListener(eventName, handler, false)
      })
      this.heartbeatListenersRegistered = true
    },
    unregisterHeartbeatListeners () {
      if (!this.heartbeatListenersRegistered) {
        return
      }

      this.getHeartbeatListeners().forEach(({ eventName, handler }) => {
        document.removeEventListener(eventName, handler, false)
      })
      this.heartbeatListenersRegistered = false
    },
    getHeartbeatListeners () {
      if (!this.heartbeatMouseMoveHandler) {
        this.heartbeatMouseMoveHandler = this.markPhysicianActivity
      }

      if (!this.heartbeatVisibilityChangeHandler) {
        this.heartbeatVisibilityChangeHandler = this.handleHeartbeatVisibilityChange
      }

      return [
        {
          eventName: 'mousemove',
          handler: this.heartbeatMouseMoveHandler
        },
        {
          eventName: 'visibilitychange',
          handler: this.heartbeatVisibilityChangeHandler
        }
      ]
    },
    handleHeartbeatVisibilityChange () {
      this.handleStillReportingVisibilityChange()
    },
    markPhysicianActivity () {
      if (!this.isHeartbeatRouteEligible()) {
        return
      }
      this.hasActivitySinceLastHeartbeat = true
      this.lastActivityAt = new Date()
      this.markStillReportingActivity()
    },
    async sendPhysicianHeartbeat () {
      if (!this.shouldSendPhysicianHeartbeat()) {
        return false
      }

      const payload = this.getHeartbeatPayload()

      if (!payload) {
        return false
      }

      try {
        await this.postPhysicianHeartbeat(payload)
        this.hasActivitySinceLastHeartbeat = false
        return true
      } catch (error) {
        return false
      }
    },
    shouldSendPhysicianHeartbeat () {
      return this.hasActivitySinceLastHeartbeat
    },
    getHeartbeatPayload () {
      const currentExamId = this.getHeartbeatExamId()
      const activityOriginId = this.getHeartbeatOriginId()

      if (typeof currentExamId === 'undefined' || !activityOriginId) {
        return null
      }

      return {
        currentExamId,
        activityOriginId
      }
    },
    getHeartbeatExamId () {
      if (this.hasNoExamsAvailable) {
        return null
      }
      return this.currentExam && this.currentExam.examId ? this.currentExam.examId : undefined
    },
    getHeartbeatOriginId () {
      if (!this.isHeartbeatRouteEligible()) {
        return null
      }

      return CONSTANTS.PHYSICIAN_ACTIVITY_ORIGIN.LAUDAR_RADIO
    },
    isHeartbeatRouteEligible () {
      return this.$route && this.$route.name === 'laudarRadio'
    },
    startStillReportingMonitor () {
      if (this.stillReportingMonitorInterval) {
        return
      }

      this.resetStillReportingMonitorState()
      this.stillReportingMonitorInterval = setInterval(() => {
        this.checkStillReportingInactivity()
      }, 1000)
    },
    stopStillReportingMonitor () {
      clearInterval(this.stillReportingMonitorInterval)
      this.stillReportingMonitorInterval = null
      this.stillReportingExpiresAt = null
      this.stillReportingPopupVisible = false
      this.lastStillReportingActivityAt = null
    },
    resetStillReportingMonitorState () {
      this.stillReportingPopupVisible = false
      this.lastStillReportingActivityAt = new Date()
    },
    setStillReportingExamDeadline () {
      const reportTimerInMinutes = this.getCurrentExamReportTimer()
      this.stillReportingExpiresAt = Date.now() + (reportTimerInMinutes * 60 * 1000)
    },
    markStillReportingActivity () {
      if (!this.isHeartbeatRouteEligible() || document.hidden || this.isStillReportingDialogOpen()) {
        return
      }

      this.lastStillReportingActivityAt = new Date()
      this.stillReportingPopupVisible = false
    },
    handleStillReportingVisibilityChange () {
      if (document.hidden) {
        this.stillReportingPopupVisible = false
        return
      }

      this.lastStillReportingActivityAt = new Date()
    },
    async handleStillReportingContinue ({ routeName, isStillReportingFromInactivity } = {}) {
      if (routeName !== 'laudarRadio' || !isStillReportingFromInactivity) {
        return
      }

      await this.refreshStillReportingTimeout()
    },
    checkStillReportingInactivity () {
      if (!this.isHeartbeatRouteEligible() || document.hidden || this.isStillReportingDialogOpen()) {
        return
      }

      const examExpiresAt = this.getCurrentExamTimerExpiresAt()
      if (!examExpiresAt || !this.lastStillReportingActivityAt) {
        return
      }

      const now = Date.now()
      const hasExamTimerExpired = Number.isNaN(examExpiresAt) || now >= examExpiresAt

      if (hasExamTimerExpired || this.stillReportingPopupVisible) {
        return
      }

      const inactiveFor = now - new Date(this.lastStillReportingActivityAt).getTime()
      if (inactiveFor < this.getStillReportingInactivityTimeoutInMilliseconds()) {
        return
      }

      this.stillReportingPopupVisible = true
      this.$root.$emit('showFeedbackPopup', true)
    },
    getCurrentExamReportTimer () {
      const reportTimer = this.examDetails?.reportTimer ?? this.currentExam?.reportTimer
      return getReportTimerMinutesWithFallback(reportTimer)
    },
    getCurrentExamTimerExpiresAt () {
      return this.stillReportingExpiresAt
    },
    getStillReportingInactivityTimeoutInMilliseconds () {
      const reportTimerInMinutes = this.getCurrentExamReportTimer()
      return reportTimerInMinutes * STILL_REPORTING_INACTIVITY_TIMEOUT_PERCENTAGE * 60 * 1000
    },
    isStillReportingDialogOpen () {
      return this.$refs.feedback && this.$refs.feedback.showDialog && this.$refs.feedback.type === 'stillReporting'
    },
    async refreshStillReportingTimeout () {
      const examId = this.getHeartbeatExamId()

      if (!examId || this.isRefreshingStillReportingTimeout) {
        return
      }

      this.isRefreshingStillReportingTimeout = true
      this.$root.$emit('showLoading')

      try {
        await this.refreshReportTime(examId)
        this.setStillReportingExamDeadline()
        this.resetStillReportingMonitorState()
      } catch (error) {
      } finally {
        this.isRefreshingStillReportingTimeout = false
        this.$root.$emit('hideLoading')
      }
    }
  }
}
